module.exports = __webpack_public_path__ + "static/media/IMG_7044.b6c1a01b.jpg";